<div class="wraper">
  <div class="container">
    <div class="row justify-content-between">
      <div class="col-lg-4 top">
        <a
          [routerLink]="'.'"
          [queryParams]="{ reg: referralId }"
          [fragment]="'reg_form'"
          class="sign_up_button go"
          data-aos="fade-right"
        >
          Sign Up</a
        >
        <!-- <a routerLink="/auth/login" class="sign_in_button" data-aos="fade-left">Sign In</a> -->
      </div>
      <div class="col-lg-4 top">
        <div class="name_text" data-aos="fade-down">
          You Are Invited By : {{ userName }}
        </div>
      </div>
    </div>
    <div class="row justify-content-center banner">
      <div class="col-lg-12">
        <h1 data-aos="zoom-in">Witness the Business Miracle!</h1>
        <h4 data-aos="fade-right">
          Now Open in <span id="city">{{ city }}</span
          >, <span id="country">{{ country }}</span>
          <input
            type="hidden"
            id="ipadress"
            name="ipadress"
            value="14.97.11.70, 192.180.10.18"
          />
          <input
            type="hidden"
            id="key"
            name="key"
            value="56e0d8aaef9f0c485ac454467477cbd3"
          />
          <br />Worldwide Priority Placement Available
        </h4>
        <h5 data-aos="fade-left">MARKETING SOLUTION</h5>
      </div>
    </div>

    <div class="sec_two">
      <div class="row justify-content-between main">
        <div class="col-lg-7">
          <div class="video_box" data-aos="zoom-in-up">
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation19/images/top_left_video_image.png"
              class="img-fluid"
              alt="image"
            />
            <div class="play_button">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation19/images/play_button.png"
                class="img-fluid"
                alt="image"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#myModal1"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <h4 data-aos="fade-left">
            Build your business with least efforts and let the power of Internet
            change the business equation.
          </h4>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <h3 data-aos="fade-down">
            Inviting you to a life changing business opportunity that will give
            wings to your business concepts and give you the flight of your
            dreams
          </h3>
        </div>
      </div>
    </div>

    <div class="sec_two">
      <div class="row justify-content-between main">
        <div class="col-lg-5">
          <h4 data-aos="fade-right">
            Make the system as a stepping stone to your success!
          </h4>
          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'reg_form'"
            class="reg_button"
          >
            REGISTER HERE</a
          >
        </div>
        <div class="col-lg-7">
          <div class="video_box" data-aos="zoom-in">
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation19/images/video_image_two.png"
              class="img-fluid"
              alt="image"
            />
            <div class="play_button">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation19/images/play_button.png"
                class="img-fluid"
                alt="image"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#myModal2"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <h3 data-aos="fade-up">
            We offer you the strongest virtual business infrastructure.
            Thousands of business professional have already taken a step ahead
            and registered on the O-Founders.
          </h3>
        </div>
      </div>
    </div>

    <div class="sec_two">
      <div class="row justify-content-between main">
        <div class="col-lg-7">
          <div class="video_box" data-aos="zoom-in">
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation19/images/video_image_three.png"
              class="img-fluid"
              alt="image"
            />
            <div class="play_button">
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation19/images/play_button.png"
                class="img-fluid"
                alt="image"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#myModal3"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <h4 data-aos="fade-left">
            global marketing campaigns laid down to let the members enjoy the
            system benefits at fullest. We offer you stable income for the rest
            of your life.
          </h4>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <ul>
            <li data-aos="fade-right" data-aos-duration="500">
              An Upgraded Marketing Automation
            </li>
            <li data-aos="fade-right" data-aos-duration="1000">
              Guaranteed Web Traffic
            </li>
            <li data-aos="fade-right" data-aos-duration="1500">
              Instant Earnings
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="sec_three">
      <div class="row">
        <div class="col-lg-3">
          <h3 data-aos="fade-up" data-aos-duration="500">
            Proceed with a positive mindset and Win Big!
          </h3>
        </div>
        <div class="col-lg-6">
          <div
            class="sec_three_mid_image"
            data-aos="zoom-in"
            data-aos-duration="1000"
          >
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation19/images/sec_three_mid_image.png"
              class="img-fluid"
              alt="image"
            />
          </div>
        </div>
        <div class="col-lg-3">
          <h1 data-aos="fade-left" data-aos-duration="1500">
            BE THE CHANGE! YOU OWE THIS TO YOUR FAMILY AND YOURSELF
          </h1>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12 text-center">
          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'reg_form'"
            class="reg_button"
          >
            REGISTER HERE</a
          >
        </div>
      </div>
    </div>

    <div class="sec_four">
      <div class="row">
        <div class="col-lg-12">
          <h1 data-aos="fade-down">Choose from</h1>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-7">
          <div class="sec_four_mid_box">
            <div
              class="first_box"
              data-aos="fade-right"
              data-aos-duration="500"
            >
              <span>1</span>
              <p>
                You can wait for the business to launch. Select a business
                package for $25 and purchase a founders position for $997.
                However, this 'founder' position depends on the availability of
                the spots.
              </p>
            </div>
            <div class="sec_box" data-aos="fade-left" data-aos-duration="1000">
              <span>2</span>
              <p>
                Request a Founders position NOW for a 90% discounted one-time
                fee of $97 to join the 1% at the top before the entire market
                joins. HIGHLY RECOMMENDED!
              </p>
            </div>
          </div>
        </div>
        <h4 data-aos="fade-down">
          Choose the second option and change your own fortune!
        </h4>
      </div>
    </div>

    <div class="sec_two">
      <div class="row justify-content-between main">
        <div class="col-lg-7">
          <div class="video_box" data-aos="zoom-in">
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation19/images/video_image_main.png"
              class="img-fluid"
              alt="image"
            />
            <div class="play_back_box">
              <h6>Previous webinar playback</h6>
              <img
                src="{{
                  myLinksS3URL
                }}frontend/presentation19/images/play_button.png"
                class="img-fluid play_main_button"
                alt="image"
                data-toggle="modal"
                data-backdrop="static"
                data-keyboard="false"
                data-target="#previous"
              />
            </div>
          </div>
        </div>
        <div class="col-lg-5" data-aos="fade-left" data-aos-duration="1000">
          <h1>WEBINAR</h1>
          <a
            [routerLink]="'.'"
            [queryParams]="{ reg: referralId }"
            [fragment]="'reg_form'"
            class="reg_button"
            >BECOME A FOUNDER</a
          >
        </div>
      </div>
    </div>

    <div class="sec_five">
      <div class="row sec_five_main">
        <div class="col-lg-6">
          <div class="sec_five_left_box" data-aos="fade-right">
            <h1>WELCOME O-Founders</h1>
            <p>
              Miracle happens when a system with automation and top-notch
              technology runs to ensure continuous traffic and sign-ups that
              reaps a constant residual income. Our System Effortlessly..
            </p>
            <p>
              Builds Your Team and Grows Your Business. Rotates Limitless Fresh
              Websites and Landing Pages. Automatically Sends Traffic to Your
              Sites. Seamlessly Recruits, Converts, and Closes For You!
            </p>
            <!--<a [routerLink]="'.'" [queryParams]="{id: referralId}"
            [fragment]="'reg_form'" class="become_button">BECOME A FOUNDER</a>-->
          </div>
        </div>

        <div class="col-lg-6 form_main" id="reg_form">
          <h4>Already a Founder?</h4>
          <div class="form_box">
            <h2>REGISTER</h2>

            <form [formGroup]="registerForm">
              <div class="row reg">
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <input
                      matInput
                      type="text"
                      class="log_in_fild form-control"
                      placeholder="First Name"
                      formControlName="firstname"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'required'
                        ) && registerForm.controls['firstname'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      First Name Required.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 1, max 50 characters.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containOnlyNumbers'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containOnlySpecialChars'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only special characters are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveSpaces'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive spaces are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveDots'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dots are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveHyphens'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dashes are not allowed.
                    </span>

                    <span
                      *ngIf="
                        registerForm.controls['firstname'].hasError(
                          'containConsecutiveUnderScores'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive underscores are not allowed.
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <input
                      matInput
                      type="text"
                      placeholder="Last Name"
                      class="log_in_fild form-control"
                      formControlName="lastname"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'required'
                        ) && registerForm.controls['lastname'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Last Name Required.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 1, max 50 characters.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containOnlyNumbers'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containOnlySpecialChars'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Only special characters are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveSpaces'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive spaces are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveDots'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dots are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveHyphens'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive dashes are not allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['lastname'].hasError(
                          'containConsecutiveUnderScores'
                        )
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Consecutive underscores are not allowed.
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <input
                      matInput
                      type="text"
                      placeholder="Email Address"
                      class="log_in_fild form-control"
                      formControlName="email"
                      required
                    />

                    <span
                      *ngIf="
                        registerForm.controls['email'].hasError('required') &&
                        registerForm.controls['email'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Email id Required.
                    </span>
                    <span
                      *ngIf="registerForm.controls['email'].hasError('pattern')"
                      class="failed-validation"
                      style="color: red"
                    >
                      Please enter valid email.
                    </span>
                    <!-- <span *ngIf="registerForm.controls['email'].hasError('maxLength')" 
                                   class="failed-validation" style="color: red">
                                    Email length sould be less than 100.
                                  </span>-->
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group d-block">
                    <div class="password-block">
                      <input
                        matInput
                        placeholder="Password"
                        formControlName="password"
                        class="log_in_fild form-control"
                        [type]="pwdToggle ? 'text' : 'password'"
                        required
                      />
                      <button
                        type="button"
                        class="password-icon"
                        (click)="pwdToggle = !pwdToggle"
                      >
                        <i
                          class="fal"
                          [ngClass]="{
                            'fa-eye': pwdToggle,
                            'fa-eye-slash': !pwdToggle
                          }"
                        ></i>
                      </button>
                    </div>
                    <span
                      *ngIf="
                        registerForm.controls['password'].hasError(
                          'required'
                        ) && registerForm.controls['password'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Password Required
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['password'].hasError('pattern')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Password should contain minimum 8 Characters and Atleast
                      one Uppercase, One Lowercase, one Number and one Special
                      Characters
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <input
                      matInput
                      type="text"
                      placeholder="Phone Number"
                      class="log_in_fild form-control"
                      formControlName="phone"
                      onKeyPress="if(this.value.length==20) return false;"
                      onkeydown="return event.keyCode !== 69"
                      required
                    />
                    <span
                      *ngIf="
                        registerForm.controls['phone'].hasError('required') &&
                        registerForm.controls['phone'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Phone number is required.
                    </span>
                    <span
                      *ngIf="registerForm.controls['phone'].hasError('pattern')"
                      class="failed-validation"
                      style="color: red"
                    >
                      Only numbers are allowed.
                    </span>
                    <span
                      *ngIf="
                        registerForm.controls['phone'].hasError('minlength') ||
                        registerForm.controls['phone'].hasError('maxlength')
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Min 6 and max 20 digits.
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-block form-group">
                    <select
                      formControlName="country_id"
                      required
                      class="log_in_fild form-control"
                    >
                      <option value="">Select Country</option>
                      <option
                        *ngFor="let country of countriesList"
                        [value]="country.countryId"
                      >
                        {{ country.countryName }}
                      </option>
                    </select>
                    <span
                      *ngIf="
                        registerForm.controls['country_id'].hasError(
                          'required'
                        ) && registerForm.controls['country_id'].touched
                      "
                      class="failed-validation"
                      style="color: red"
                    >
                      Plese Select Country
                    </span>
                  </div>
                </div>
              </div>
              <!-- <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="row no-gutters">
                                        <div class="capcha form-control">
                                            <img [src]="imageCaptcha" style="width: 150px" />
                                        </div>

                                        <div class="refresh-icn">
                                            <i class="fa fa-refresh fa-lg" aria-hidden="true" (click)="regenerateCaptcha()"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="main input-effect">
                                        <input id="capcha" maxlength="5" name="capcha" type="text" formControlName="enteredCaptcha" placeholder=" Enter Captcha" class="form-control effect-19" required="required" />
                                        <span *ngIf="
                          registerForm.controls['enteredCaptcha'].hasError(
                            'required'
                          ) && registerForm.controls['enteredCaptcha'].touched
                        " class="failed-validation" style="color: red">
                        Captcha Required
                      </span>
                                    </div>
                                </div>
                            </div>
                        </div>-->
              <div class="text-center">
                <button
                  mat-raised-button
                  type="submit"
                  (click)="submitRegister()"
                  [disabled]="registerForm.invalid"
                  class="ibtn w-100"
                >
                  SignUp
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sec_two">
    <div class="container">
      <div class="row justify-content-between main">
        <div class="col-lg-6">
          <div class="video_box" data-aos="zoom-in">
            <img
              src="{{
                myLinksS3URL
              }}frontend/presentation19/images/testimonials_left_image.png"
              class="img-fluid"
              alt="image"
            />
          </div>
        </div>
        <div class="col-lg-6 mb-5">
          <div class="testimonilas_box">
            <div id="testimonial-slider" class="">
              <ngx-slick-carousel
                class="carousel"
                #slickModal="slick-carousel"
                [config]="slideConfig"
                (init)="slickInit($event)"
              >
                <div ngxSlickItem class="testimonial-content">
                  <div class="cd-author">
                    <img
                      src="{{ cloudFrontUrl }}uploads/t1.png"
                      alt="Author image"
                    />
                  </div>

                  <h2>An ideal model for anyone</h2>

                  <p>
                    His drive and passion for creating a platform to help
                    everyone from seasoned marketers to the "little guy" helped
                    solidify my belief Then learning how we benefit financially
                    with optional starting points, makes this an ideal model for
                    anyone with a business who needs advertising.
                  </p>

                  <p>
                    Thank you Ash for your vision and help for so many people
                    around the world.
                  </p>

                  <ul class="cd-author-info">
                    <li>Tim <strong>Leach</strong></li>

                    <li></li>
                  </ul>
                </div>

                <div ngxSlickItem class="testimonial-content">
                  <div class="cd-author">
                    <img
                      src="{{ cloudFrontUrl }}uploads/t4.png"
                      alt="Author image"
                    />
                  </div>

                  <h2>This Will Undoubtedly Change Your Life!</h2>

                  <p>
                    I want to personally say thank you to everyone on this
                    awesome journey that Ash Murareh has created. As many of you
                    may not know, Ash is a very successful online marketer and
                    has made his living in this industry building massive teams
                    for various companies. He saw a big need for creating a
                    company that would help the average person succeed online so
                    he decided to build it himself.
                  </p>

                  <p>
                    When you listen to his Founder's presentations or when you
                    speak with him, you will immediately feel his passion to
                    build a highly effective business where every single person
                    will be successful.
                  </p>

                  <ul class="cd-author-info">
                    <li>Mike <strong>Williams</strong></li>

                    <li></li>
                  </ul>
                </div>

                <div ngxSlickItem class="testimonial-content">
                  <div class="cd-author">
                    <img
                      src="{{ cloudFrontUrl }}uploads/t2.png"
                      alt="Author image"
                    />
                  </div>

                  <h2>
                    I am totally blown away and will build my final dynasty
                  </h2>

                  <p>
                    In my 19 years successful career in this space,I have never
                    seen a business so full, so disruptive, so intriguing that
                    everyone I approach is excited to belong.
                  </p>

                  <p>
                    Did a Facebook post, alongside my WhatsApp campaign, on the
                    founder position, that attracted 122 comments, 14 people
                    have joined direct to me and in less than 48 hours, 59 super
                    qualified leads have submitted their email, requesting
                    information to be founders, AND ALL THESE WITHOUT ANYTHING
                    YET ONGROUND, not even a website. I am totally blown away
                    and will build my final dynasty here in ONPASSIVE.
                  </p>

                  <ul class="cd-author-info">
                    <li>PRINCE <strong>OBI</strong></li>

                    <li></li>
                  </ul>
                </div>
              </ngx-slick-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="myModal1" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="first_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video1.pause(); video1.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video1
        id="my-video"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting1-new.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/video1-compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="myModal2" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="second_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video2.pause(); video2.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video2
        id="my-video1"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/greetingsgofound/images/greeting2.png"
      >
        <source
          src="{{ myLinksS3URL }}videos/Video2-Compressed-new.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="myModal3" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          id="third_video_pause"
          class="close"
          data-dismiss="modal"
          (click)="video3.pause(); video3.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video3
        id="my-video2"
        class="video-js"
        controls
        preload="auto"
        poster="{{
          myLinksS3URL
        }}frontend/invitationfive/images/greeting3-new.png"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          type="video/mp4"
        />

        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to
          a web browser that
          <a
            href="https://videojs.com/html5-video-support/"
            target="_blank"
            rel="noopener"
            >supports HTML5 video</a
          >
        </p>
      </video>
    </div>
  </div>
</div>

<div id="previous" class="modal fade" role="dialog">
  <div class="modal-dialog modal-lg">
    <!-- Modal content-->

    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          id="prev_video_pause"
          (click)="video4.pause(); video4.currentTime = 0"
        >
          &times;
        </button>
      </div>

      <video
        #video4
        width="100%"
        class="video-js"
        controls
        preload="auto"
        poster="{{ myLinksS3URL }}videos/title.jpg"
        id="my-video"
      >
        <source
          src="{{
            myLinksS3URL
          }}videos/ONPASSIVE-BUSINESS-PRESENTATION-BLESSYOURLOVEDONES.mp4"
          id="video"
          type="video/mp4"
        />

        Your browser does not support HTML5 video.
      </video>
    </div>
  </div>
</div>
